import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import styled from "@emotion/styled";
import { setMerchantIsRequired } from "../../Merchants";
import { validateNumOrPin } from "../thunk";

const Container = styled.div`
  flex: 1 1 0%;
`;

const Pin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0.5;
`;

const Icon = styled.span`
  right: 1.2rem;
  position: relative;
  color: ${({ active }) => (active ? "#c7a878" : "#1F2021")};
`;

const CardPin = ({
  merchantSelectorFocus,
  defaultValue,
  onChange,
  hasMerchant,
  maxLength,
  validation,
}) => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(false);

  const onFocus = () => {
    if (!hasMerchant) {
      dispatch(setMerchantIsRequired(true));
      merchantSelectorFocus();
    } else {
      setActive(true);
    }
  };

  return (
    <Container>
      <Pin>
        <input
          defaultValue={defaultValue}
          type="text"
          onChange={(e) => {
            e.persist();

            const value = e.target.value.trim();
            const { error, msg } = validateNumOrPin(
              "Pin",
              value,
              validation,
              1,
              validation
                .split(", ")
                .every((v) => v.split(":")[1].trim() != "null")
            );

            onChange(e.target.name, value, error, msg);
          }}
          onFocus={() => onFocus()}
          onBlur={() => setActive(false)}
          className="form-control"
          placeholder={"Pin"}
          size={maxLength}
          name="pin"
        />

        <Icon active={active}>
          <svg
            width="12px"
            height="15px"
            viewBox="0 0 12 15"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="Flow"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
              opacity={`${active ? "1" : "0.300000012"}`}
            >
              <g
                id="icon"
                transform="translate(-776.000000, -615.000000)"
                fill="currentColor"
                fillRule="nonzero"
              >
                <g id="Form" transform="translate(219.000000, 156.000000)">
                  <g id="Group-2" transform="translate(132.000000, 459.000000)">
                    <g id="Group-5" transform="translate(322.000000, 0.000000)">
                      <g
                        id="locked"
                        transform="translate(103.000000, 0.000000)"
                      >
                        <path
                          d="M10,7 L10,4 C10,1.790861 8.209139,0 6,0 C3.790861,0 2,1.790861 2,4 L2,7 C0.8954305,7 0,7.8954305 0,9 L0,13 C0,14.1045695 0.8954305,15 2,15 L10,15 C11.1045695,15 12,14.1045695 12,13 L12,9 C12,7.8954305 11.1045695,7 10,7 Z M6,12.75 C5.31,12.75 4.75,11.965 4.75,11 C4.75,10.035 5.31,9.25 6,9.25 C6.69,9.25 7.25,10.035 7.25,11 C7.25,11.965 6.69,12.75 6,12.75 Z M8,7 L4,7 L4,4 C4,2.8954305 4.8954305,2 6,2 C7.1045695,2 8,2.8954305 8,4 L8,7 Z"
                          id="Shape"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </Icon>
      </Pin>
    </Container>
  );
};

CardPin.DefaultProps = {
  defaultValue: null,
  validation: "",
};

CardPin.propTypes = {
  merchantSelectorFocus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  hasMerchant: PropTypes.bool.isRequired,
  validation: PropTypes.string.isRequired,

  maxLength: PropTypes.number,
  defaultValue: PropTypes.string,
};

export { CardPin };
